var map = {
	"./Mastercard.svg": 6251,
	"./appstore.svg": 43787,
	"./award-01.svg": 39814,
	"./award-02.svg": 76037,
	"./award-03.svg": 98020,
	"./banner-book.svg": 83613,
	"./banner-icon-01.svg": 51339,
	"./banner-icon-02.svg": 12504,
	"./banner-icon-03.svg": 47369,
	"./banner-icon-04.svg": 44774,
	"./be.svg": 60580,
	"./benefit-icon-01.svg": 14722,
	"./benefit-icon-02.svg": 35089,
	"./benefit-icon-03.svg": 99136,
	"./book.svg": 57796,
	"./book2.svg": 71678,
	"./book3.svg": 15407,
	"./calendar.svg": 90681,
	"./calendar2.svg": 81289,
	"./card.svg": 83473,
	"./category-1.svg": 48929,
	"./category-10.svg": 42755,
	"./category-11.svg": 28114,
	"./category-2.svg": 43890,
	"./category-3.svg": 47203,
	"./category-4.svg": 49276,
	"./category-5.svg": 77821,
	"./category-6.svg": 31550,
	"./category-7.svg": 51599,
	"./category-8.svg": 35976,
	"./category-9.svg": 48345,
	"./category-icon1.svg": 28035,
	"./category-icon10.svg": 24224,
	"./category-icon11.svg": 64785,
	"./category-icon12.svg": 84386,
	"./category-icon2.svg": 16515,
	"./category-icon3.svg": 83474,
	"./category-icon4.svg": 17405,
	"./category-icon5.svg": 88860,
	"./category-icon6.svg": 67887,
	"./category-icon7.svg": 5310,
	"./category-icon8.svg": 97510,
	"./category-icon9.svg": 9736,
	"./chart.svg": 39189,
	"./cloud-lightning.svg": 18695,
	"./count-four.svg": 8089,
	"./count-one.svg": 67367,
	"./count-three.svg": 50007,
	"./count-two.svg": 39093,
	"./counter-icon1.svg": 85714,
	"./counter-icon2.svg": 51105,
	"./counter-icon3.svg": 52656,
	"./counter-icon4.svg": 70127,
	"./course-01.svg": 18136,
	"./facebook.svg": 35623,
	"./fb.svg": 19599,
	"./figma.svg": 73829,
	"./google.svg": 60366,
	"./googleplay.svg": 39900,
	"./how-it-works-1.svg": 35400,
	"./how-it-works-2.svg": 16763,
	"./how-it-works-3.svg": 74794,
	"./icon-1.svg": 69170,
	"./icon-10.svg": 2766,
	"./icon-11.svg": 31199,
	"./icon-12.svg": 52172,
	"./icon-13.svg": 51117,
	"./icon-14.svg": 80898,
	"./icon-15.svg": 86067,
	"./icon-16.svg": 65312,
	"./icon-17.svg": 1265,
	"./icon-18.svg": 3110,
	"./icon-19.svg": 1143,
	"./icon-2.svg": 57857,
	"./icon-20.svg": 33155,
	"./icon-21.svg": 18514,
	"./icon-22.svg": 11649,
	"./icon-23.svg": 76112,
	"./icon-24.svg": 41999,
	"./icon-25.svg": 98270,
	"./icon-26.svg": 52445,
	"./icon-27.svg": 62972,
	"./icon-28.png": 20911,
	"./icon-29.png": 52166,
	"./icon-3.svg": 66736,
	"./icon-30.svg": 71616,
	"./icon-31.png": 24149,
	"./icon-32.svg": 28898,
	"./icon-33.svg": 16275,
	"./icon-34.svg": 10060,
	"./icon-4.svg": 76879,
	"./icon-5.svg": 40478,
	"./icon-6.svg": 3101,
	"./icon-7.svg": 74556,
	"./icon-8.svg": 76795,
	"./icon-9.svg": 7978,
	"./import.svg": 11304,
	"./instagram.svg": 44493,
	"./instructor-icon1.svg": 13389,
	"./instructor-icon2.svg": 61889,
	"./instructor-icon3.svg": 5375,
	"./instructor-icon4.svg": 46816,
	"./joing-01.svg": 61362,
	"./joing-02.svg": 88782,
	"./joing-03.svg": 75280,
	"./joing-04.svg": 69071,
	"./key.svg": 33656,
	"./linkedin.svg": 41185,
	"./meet-icon-1.svg": 84582,
	"./meet-icon-2.svg": 83717,
	"./monitor-mobbile.svg": 5796,
	"./note.svg": 33795,
	"./paypal-2.svg": 99567,
	"./paypal.svg": 59942,
	"./people.svg": 78758,
	"./people2.svg": 22344,
	"./people3.svg": 87737,
	"./play.svg": 97749,
	"./play2.svg": 80189,
	"./play3.svg": 90716,
	"./review.svg": 90759,
	"./rupee.svg": 98070,
	"./save-10.svg": 55222,
	"./sign.svg": 33760,
	"./stripe.svg": 16520,
	"./subscribe-icon-01.svg": 55695,
	"./subscribe-icon-02.svg": 76668,
	"./tag.svg": 93186,
	"./teacher.svg": 86203,
	"./timer-start.svg": 43737,
	"./timer-start2.svg": 6249,
	"./timer-start3.svg": 2008,
	"./verify-icon.svg": 73914,
	"./visa-logo.svg": 65412,
	"./vision-icon-01.svg": 38517,
	"./vision-icon-02.svg": 97270,
	"./vision-icon-03.svg": 84391,
	"./vision-icon-04.svg": 64584,
	"./x.svg": 95081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;